import React from 'react';
import { planCreditQuote, screenChangeQuote } from '../lib/planCreditPolicy';

/** Quote presentation only; never enables submission on a missing policy. */
export default function PlanCreditSummary({ policy, screens, technicalCap, currentScreens, expiryLabel, bonusScreens = 0 }) {
  const changing = currentScreens !== undefined;
  const quote = changing
    ? screenChangeQuote(policy, currentScreens, screens, technicalCap)
    : planCreditQuote(policy, screens, technicalCap);
  if (!quote) return (
    <div role="alert" className="rounded-md border border-destructive/40 bg-destructive/10 p-3 text-sm">
      Custo indisponível. Revise a regra do plano e o limite de telas antes de confirmar.
    </div>
  );
  return (
    <section aria-label="Resumo dos créditos e telas" aria-live="polite" className="space-y-3 rounded-md border border-border bg-muted/30 p-4 text-sm">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h4 className="font-semibold">Créditos e telas</h4>
        {quote.additionalScreens > 0 && (
          <span className="rounded border border-primary/30 bg-primary/10 px-2 py-1 text-primary">
            +{quote.additionalScreens} {quote.additionalScreens === 1 ? 'tela adicional' : 'telas adicionais'}
          </span>
        )}
      </div>
      <dl className="grid grid-cols-2 gap-2">
        <dt>Telas incluídas no plano</dt><dd className="text-right">{quote.includedScreens}</dd>
        <dt>Telas adicionais</dt><dd className="text-right">{quote.additionalScreens}</dd>
        <dt>Total de telas simultâneas</dt><dd className="text-right">{quote.totalScreens + bonusScreens}</dd>
        {bonusScreens > 0 && <><dt>Telas bonificadas sem cobrança</dt><dd className="text-right">{bonusScreens}</dd></>}
        <dt>Créditos do plano</dt><dd className="text-right">{quote.baseCredits}</dd>
        <dt>Créditos das telas adicionais</dt><dd className="text-right">{quote.additionalCredits}</dd>
        <dt className="font-semibold">{changing ? 'Total na próxima renovação' : 'Total de créditos'}</dt>
        <dd className="text-right font-semibold">{quote.totalCredits}</dd>
        {changing && <><dt className="font-semibold">Débito agora</dt><dd className="text-right font-semibold">{quote.chargeNow}</dd></>}
      </dl>
      <p className="text-muted-foreground">Cada tela adicional custa 1 crédito na ativação e em cada renovação enquanto for mantida.</p>
      {changing && <p className="text-muted-foreground">O vencimento permanece {expiryLabel || 'o mesmo'}. Adicionar telas durante a validade gera débito imediato. Remover telas não gera estorno; reduz a cobrança da próxima renovação.</p>}
    </section>
  );
}
